import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import CommentThread from "@/components/CommentThread";

// OP-036: /threads/{video_id}. Decision and follow-up links lead here in personal and workspace scope. The page reads
// only GET /videos/{id}/comments, so it works when the video was removed from Saved or is missing from the catalogue.
export default function ThreadPage() {
  const { videoId } = useParams();
  const { user } = useAuth();
  return (
    <div className="space-y-4" data-testid="thread-page">
      <Link to="/decisions" className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-1" data-testid="thread-back-link">
        <ArrowLeft className="h-4 w-4" aria-hidden="true" /> Decision Board
      </Link>
      <CommentThread key={`${videoId}-${user?.id || ""}-${user?.workspace_id || "personal"}`} videoId={videoId} standalone />
    </div>
  );
}
